import { requestApiV2 } from '@library'
import { CommonList, KnowledgeListParam, KnowledgeItem, KnowledgeUploadParam, TrpcCbmBackendOServiceChatAddDocumentReq, TrpcCbmBackendOServiceChatAddDocumentRsp } from '@types'

// 获取知识库文档列表
export function getKnowledgeList (filter: KnowledgeListParam) {
  return requestApiV2<CommonList<KnowledgeItem>>('trpc.tcc.tcc_main.Knowledge/GetDocumentList', filter)
}

// 新增知识库文档
export function uploadKnowledgeDocument (params: KnowledgeUploadParam) {
  return requestApiV2<{ data: { id: number } }>('trpc.tcc.tcc_main.Knowledge/AddDocument', params)
}

// 获取环境相关信息 云存储路径前缀
export function getSDRIntentionLeadUploadPath () {
  return requestApiV2<{ path: string }>('trpc.tcc.tcc_main.Knowledge/GetSDRKnowledgeUploadPath')
}
